/* global Image */
import React, { Component } from 'react'
import './Info.css'
import { ControlInput, ControlSelect } from '../commons/Controls'
import Dropzone from 'react-dropzone'

class Info extends Component {
  constructor (props) {
    super(props)
    this.state = {
      file: null
    }
    this.handleFile = this.handleFile.bind(this)
  }
  handleFile (file) {
    // Create preview URL for the file
    const fileWithPreview = file.map(f => Object.assign(f, {
      preview: URL.createObjectURL(f)
    }))
    
    this.setState({
      file: fileWithPreview
    })
    const image = new Image()
    const ctx = this.canvas.getContext('2d')
    image.onload = function () {
      let width = image.width
      let height = image.height
      let ratio = height / width
      let newHeight = 400
      let newWidth = Math.round(newHeight / ratio)
      let xPos = (newWidth - 400) / -2
      ctx.drawImage(image, xPos, 0, newWidth, newHeight)
    }
    image.src = fileWithPreview[0].preview
    this.props.handleCover(this.canvas)
  }
  render () {
    return (
      <div className='info'>
        <ControlInput
          type='text'
          label='Nombre del grupo'
          value={this.props.title}
          onChange={(ev) => this.props.handleTitle(ev.target.value)}
          placeholder='Título para identificar el grupo'
        />
        {this.props.modes ? <ControlSelect
          label='Modalidad de quiniela'
          value={this.props.mode}
          options={this.props.modes}
          onChange={(ev) => this.props.handleMode(ev.target.value)}
          placeholder='Escoge una opción'
        /> : <ControlInput
          type='text'
          label='Modalidad de quiniela'
          value={this.props.mode}
          readOnly
        />}
        <Dropzone
          multiple={false}
          accept={{
            'image/png': ['.png'],
            'image/jpeg': ['.jpg', '.jpeg']
          }}
          onDropAccepted={this.handleFile}>
          {({getRootProps, getInputProps}) => (
            <div {...getRootProps()} className='info__cover'>
              <input {...getInputProps()} />
              {this.state.file ? <img src={this.state.file[0].preview} alt='Cover' /> : this.props.current ? <img src={this.props.current} alt='Cover' /> : <div className='info__cover__empty'><i className='material-icons'>add_photo_alternate</i><br /><span>Agregar ícono del grupo</span></div>}
              <canvas width='400' height='400' style={{display: 'none'}} ref={(el) => { this.canvas = el }} />
            </div>
          )}
        </Dropzone>
      </div>
    )
  }
}

export default Info
